module.exports = __webpack_public_path__ + "img/mbway.71685191.svg";